import { render, staticRenderFns } from "./LicenceCard.vue?vue&type=template&id=6323083d&"
import script from "./LicenceCard.vue?vue&type=script&lang=js&"
export * from "./LicenceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports